<template>
  <div>
    <h4
      class="text-uppercase size-md"
      style="letter-spacing: var(--letter-spacing-2xl); font-weight: 700"
    >
      <span
        v-if="isShowingFamilyName"
        class="display-inline-block margin-bottom-2xs padding-x-2xs padding-y-3xs size-sm"
        :style="selectStyle"
      >
        {{ familyName }}
      </span>
      <span class="display-block">{{ styleName }}</span>
    </h4>
    <p class="margin-0 size-sm">
      {{ styleDescription }}
    </p>
  </div>
</template>

<script>
  export default {
    name: 'CardCopy',

    props: {
      cardColor: {
        type: String
      },
      familyName: {
        type: String
      },
      styleDescription: {
        type: String
      },
      styleName: {
        type: String
      },
      isDarkTheme: {
        type: Boolean
      }
    },

    computed: {
      isShowingFamilyName() {
        if (this.familyName === 'Classic') {
          return false
        } else {
          return true
        }
      },
      selectStyle() {
        let style = {}

        let accentColor = `var(--fa-${this.cardColor})`
        let baseColor = `var(--fa-navy)`

        style['font-family'] = 'var(--font-family-base)'
        style['margin-left'] = 'calc(-1 * var(--spacing-3xs))'
        style['line-height'] = '1'

        if (this.isDarkTheme) {
          style['background-color'] = accentColor
          style['color'] = baseColor
        } else {
          style['background-color'] = baseColor
          style['color'] = accentColor
        }

        return {
          ...style,
          ...this.customSelectStyle
        }
      }
    }
  }
</script>
